import styled, { keyframes } from 'styled-components'

export const Shine = keyframes`
  0% {
    background-position: -100px;
  }
  30% {
    background-position: -100px;
  }
  100% {
    background-position: 78vw;
  }
`

export const BoxSkeletonContainer = styled.div`
  width: 100%;
  height: ${props => props.height ? props.height : '238px'};
  
  border-radius: 20px;

  background-image: linear-gradient(90deg, #E7EDF1 0px, rgba(248, 251, 252, .1) 40px, #E7EDF1 80px);
  background-size: 88.6vw;
  animation: ${Shine} 2s linear infinite;
`
